import React, { useState } from 'react';

// Hooks
import { useNavigate } from 'react-router-dom';

//Utils
import { MESSAGES } from '~/utils/message';

// MUI Components
import { Box, MenuItem } from '@mui/material';

// Icons
import {
  NoContact2CIcon,
  Export2CIcon,
  Add3CIcon,
  Add2CIcon,
  FindNewContactsCIcon,
} from '~/assets/images';

// styles
import './styles.scss';
import CreateContactModal from '../CreateContactModal';
import EmptyStateCard from '~/components/General/EmptyStateCard';
import OlcActionMenu from '~/components/General/OlcActionMenu';
import OlcButton from '~/components/General/OlcButton';
import OlcTooltip from '~/components/General/OlcTooltip';

const NoContactsScreen = ({
  findNewContactsDisabled = false,
  findNewContactsDisabledMessage = '',
  setOpenCreateContactModal,
  openCreateContactModal,
  onFindNewContacts,
}) => {
  // Actions State

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const navigate = useNavigate();
  return (
    <>
      <Box className="olcEmptyStateToolbar">
        <OlcButton
          variant="primary"
          id="empty-contacts-create-button"
          aria-controls={open ? 'empty-contacts-create-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          startIcon={<img src={Add3CIcon} alt="" />}
          dropdown
          expanded={open}
        >
          {MESSAGES.CONTACTS.CREATE_BTN_TEXT}
        </OlcButton>
      </Box>
      <EmptyStateCard
        icon={NoContact2CIcon}
        iconAlt="no-contacts"
        title={MESSAGES.CONTACTS.NO_CONTACTS_SCREEN.TITLE}
        description={MESSAGES.CONTACTS.NO_CONTACTS_SCREEN.DESC}
      />
      <OlcActionMenu
        id="empty-contacts-create-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'empty-contacts-create-button',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        sx={{
          marginTop: '10px',
        }}
        disableScrollLock
      >
        <MenuItem
          className="menuItem"
          onClick={() => {
            setOpenCreateContactModal(true);
            handleClose();
          }}
        >
          <img src={Add2CIcon} alt="icon" />
          Create Contact
        </MenuItem>
        <MenuItem
          className="menuItem"
          onClick={() => {
            navigate('/contacts/import?origin=contacts');
          }}
        >
          <img src={Export2CIcon} alt="icon" />
          Import Contacts
        </MenuItem>
        <OlcTooltip
          arrow
          disableInteractive={!findNewContactsDisabled}
          placement="left"
          title={findNewContactsDisabled ? findNewContactsDisabledMessage : ''}
        >
          <li>
            <MenuItem
              component="div"
              className="menuItem"
              disabled={findNewContactsDisabled}
              onClick={() => {
                if (findNewContactsDisabled) return;

                onFindNewContacts();
                handleClose();
              }}
            >
              <img src={FindNewContactsCIcon} alt="icon" />
              Find New Contacts
            </MenuItem>
          </li>
        </OlcTooltip>
      </OlcActionMenu>
      <CreateContactModal
        open={openCreateContactModal}
        handleClose={() => {
          setOpenCreateContactModal(false);
        }}
      />
    </>
  );
};

export default NoContactsScreen;
